import styled from 'styled-components';

export const StyledParagraph = styled.p`
  font-size: 18px;
  line-height: 30px;
  color: #000;
`;

export const StyledParagraphHeader = styled.h2`
  font-size: 32px;
  background-color: ${({ theme }) => theme.colors.lightGray};
  display: inline;
  padding: 0 8px;
  color: #000;
  align-self: flex-start;
  &.danger {
    border: 2px solid red;
    background-color: #fff;
    font-size: 18px;
    color: red;
    display: block;
    padding: 8px;
  }
`;

export const StyledParagraphMiniHeader = styled.h3`
  font-size: 18px;
  background-color: ${({ theme }) => theme.colors.lightGray};
  display: block;
  padding: 8px;
  color: #000;
`;

export const StyledParagraphList = styled.ol`
  padding-left: 16px;
  font-size: 18px;
  li {
    color: #000;
    margin-bottom: 16px;
  }
`;
